import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        slot: "icon-only",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, "AB4 customization" + _toDisplayString(_ctx.user.schoolId ? ` [${_ctx.user.schoolId.toString().toUpperCase()}]` : ""), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        fill: "outline",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openProfessionSelectModal())),
                        class: "no-text-transform"
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode(" Preview ")
                        ])),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.loadingData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_accordion_group, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.step1Questions, (q, qIdx) => {
                        return (_openBlock(), _createBlock(_component_ion_accordion, {
                          key: q.id,
                          style: {"--min-height":"24px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              slot: "header",
                              style: {"--min-height":"24px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, [
                                      _createTextVNode(_toDisplayString(qIdx+1) + ". ", 1),
                                      _createElementVNode("b", null, "[" + _toDisplayString(q.group) + "]", 1),
                                      _createTextVNode(" " + _toDisplayString(q.title), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_list, {
                              class: "ion-no-padding",
                              slot: "content"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  color: "primary",
                                  onClick: ($event: any) => (_ctx.addNewTag(q)),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      class: "ion-text-wrap",
                                      style: {"padding-left":"20px"}
                                    }, {
                                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createElementVNode("p", null, "Add new option", -1)
                                      ])),
                                      _: 1,
                                      __: [3]
                                    }),
                                    _createVNode(_component_ion_buttons, {
                                      slot: "end",
                                      style: {"padding-right":"76px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_button, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "icon-only",
                                              icon: _ctx.add
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_ion_accordion_group, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.options, (opt, idx) => {
                                      return (_openBlock(), _createBlock(_component_ion_accordion, {
                                        key: opt.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, {
                                            color: "light",
                                            lines: "full",
                                            slot: "header",
                                            style: {"--min-height":"24px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                class: "ion-text-wrap",
                                                style: {"padding-left":"20px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, _toDisplayString(opt.text), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_ion_buttons, { slot: "end" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_button, {
                                                    onClick: _withModifiers(($event: any) => (_ctx.updateTag(opt)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        size: "small",
                                                        slot: "icon-only",
                                                        icon: _ctx.pencil
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_ion_button, {
                                                    color: "danger",
                                                    onClick: _withModifiers(($event: any) => (_ctx.deleteTag(q.options, idx)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        size: "small",
                                                        slot: "icon-only",
                                                        icon: _ctx.trashOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_ion_list, {
                                            class: "ion-no-padding",
                                            slot: "content"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedProfessions(opt), (profession) => {
                                                return (_openBlock(), _createBlock(_component_ion_item, {
                                                  lines: "full",
                                                  key: profession.id
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, {
                                                      class: "ion-text-wrap",
                                                      style: {"padding-left":"40px"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("p", null, _toDisplayString(profession.name) + " " + _toDisplayString(profession.nameChi), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}